export default function linearTranslation(value, minValue, minValueOut, maxValue, maxValueOut) {
  if (value < minValue) {
    return minValueOut;
  }
  if (value > maxValue) {
    return maxValueOut;
  }
  return Math.round(((value - minValue) / (maxValue - minValue)) * (maxValueOut - minValueOut) + minValueOut);
}